<template>
    <div class="scroll-wrapper" >
        <div class="d-flex" :id="id"
             :class=" hasScroll ?  '': 'justify-content-lg-center' ">
            <div class="text-center text-invalid" v-if="sections.length === 0">{{$t("REPORTS.NO_SECTIONS")}}</div>
            <div v-else class="d-flex justify-content-center">
                <div class="mt-3 mr-5">
                    <div>{{$t('COMMON.TEMPERATURE')}}</div>
                    <div>{{$t('COMMON.CO2')}}</div>
                    <!-- <div>{{$t('COMMON.HUMIDITY')}}</div> -->
                    <div class="text-nowrap">{{$t('COMMON.MOISTURE')}}</div>
                </div>
                <div class="d-flex">
                    <div v-for="(section,index) in this.sections">
                        <div v-if="index === 0" 
                            :class="backgroundSiloColor('left',section)">
                            <span :class="backgroundColor('temp',section)"
                              class="pt-3">{{buildText("temp",section,index)}}</span>
                            <span :class="backgroundColor('co2',section)">{{buildText("co2",section,index)}}</span>
                            <!-- <span :class="backgroundColor('hum',section)">{{buildText("hum",section)}}</span> -->
                            <span :class="backgroundColor('moisture',section)">{{buildText("moisture",section,index)}}</span>

                        </div>
                        <div v-else-if="index !== 0 && index !== (sections.length -1)"
                             :class="backgroundSiloColor('center',section)">
                        <span :class="backgroundColor('temp',section)"
                              class="pt-3">{{buildText("temp",section,index)}}</span>
                            <span :class="backgroundColor('co2',section)">{{buildText("co2",section,index)}}</span>
                          <!--  <span :class="backgroundColor('hum',section)">{{buildText("hum",section)}}</span> -->
                            <span :class="backgroundColor('moisture',section)">{{buildText("moisture",section,index)}}</span>
                        </div>
                        <div v-else-if="index === (sections.length -1)"
                             :class="backgroundSiloColor('right',section)">
                        <span :class="backgroundColor('temp',section)"
                              class="pt-3">{{buildText("temp",section,index)}}</span>
                            <span :class="backgroundColor('co2',section)">{{buildText("co2",section,index)}}</span>
                           <!-- <span :class="backgroundColor('hum',section)">{{buildText("hum",section)}}</span> -->
                            <span :class="backgroundColor('moisture',section)">{{buildText("moisture",section,index)}}</span>
                        </div>

                        <div v-if="silo.sections[index].status === 5" class="text-center"><em
                                style="font-size: 0.7em">{{$t('STATUS.DISABLED')}}</em>
                        </div>
                        <div v-else>
                            <div style="font-size: 0.8em" class=" mt-2 text-center font-weight-light text-muted">
                                <!-- {{silo.sections[index].date}} -->
                                     {{formatDate(silo.sections[index].date)}}                            
                            </div>

                            <div v-if="isSensorFail(silo.sections[index].okSensor)"
                                class="d-flex flex-column align-items-center ">
                                <!--<i style="font-size: 1.5em;" class="material-icons text-warning  ">warning</i>
                                <div style="font-size: 0.8em">{{$t("REPORTS.SENSOR_FAIL")}}</div>
                                -->
                            </div>
                            <div v-else>
                                <div v-if="isOldDate(silo.sections[index].date) "
                                 class="d-flex flex-column align-items-center ">
                                <i style="font-size: 1.5em;" class="material-icons text-warning  ">warning</i>
                                <div style="font-size: 0.8em">{{$t('ERROR.OUTDATED')}}</div>
                            </div>

                            </div>


                        </div>


                    </div>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
    import api from "../../utils/api/api";
    import unitConverter from "../../utils/unitConverter";
    //import languageSelector from "../common/languageSelector";
    import dateFormater from "../../utils/dateFormater";

    const DAY_IN_SECS = 60 * 60 * 24;
    export default {
        name: "siloImg",
        props: {
            id: {
                required: true,
                type: String
            },
            siteId: {
                required: true,
                type: String
            },
            date: {
                required: true,
                type: Date
            },
            siloName: {
                type: String,
                required: false,
            },
            siloColor :
            {
                required: true,
                type: Boolean
            }
        },
        data: function () {
            return {
                pendingSectionResult: [],
                sections: [],
                loadingInstance: undefined,
                silo: undefined,
                limits: undefined,
                today: new Date(),
                TWO_DAYS_IN_MILLIS: 172800000,
                hasScroll: false,
                langsel:  undefined
                }
        },     
        mounted: function () {
            if(this.id === undefined)
            {
                console.log("ID indefinido!!");
                return;
            }
            this.getSiloFromId(this.siteId, this.id);
        },
        computed: {
            sectionQuantity() {
                if (this.silo === undefined || this.silo.sections === undefined) {
                    return 0;
                }
                return this.silo.sections.length;
            },

        },
        watch: {
            id: function (newVal) {
                if(this.id === undefined)
                {
                    console.log("ID indefinido!!");
                    return;
                }
                this.getSiloFromId(this.siteId, newVal);
            },
            date: function (newVal) {
                //this.sections = new Array(this.sectionQuantity);
                //this.loadSections(this.sectionQuantity, this.siteId, this.id, newVal.getTime() / 1000);
            },
            siloColor: function(newVal)
            {
                //console.log("siloColor: "+newVal); 
                
                if(this.id === undefined)
                {
                    console.log("ID indefinido!!");
                    return;
                }

                this.getSiloFromId(this.siteId, this.id);
            },
            pendingSectionResult: function (newVal) {
                
                if(this.id === undefined)
                {
                    console.log("ID indefinido!!");
                    return;
                }

                
                let pending = newVal.filter(value => {
                    return (value.awaiting === undefined || value.awaiting);
                });

                if (pending.length !== 0 && this.loadingInstance === undefined) {
                    this.loadingInstance = this.$loading({target: document.getElementById(this.id)});
                }
                if (pending.length === 0) {
                    for (let i = 0; i < newVal.length; i++) {
                        this.sections.splice(i, 1, newVal[i].data)
                    }
                    if (this.loadingInstance) {
                        this.loadingInstance.close();
                        this.loadingInstance = undefined;
                    }
                    this.setScroll();
                }

            }
        },
        methods: {
            setScroll() {
                setTimeout(() => {
                    let div = document.getElementById(this.id);
                    if (div === undefined || div === null) {
                        return false;
                    }

                    this.hasScroll = div.scrollWidth > div.offsetWidth
                }, 200)

            },
            getSiloFromId(siteId, siloId) {
                api.getSilo(siteId, siloId).then(value => {
                    this.silo = value.silo;
                    api.getGrainAlertThresholds(this.silo.type).then(limits => {
                        this.limits = limits.limits;
                    });

                    const size = this.silo.sections !== undefined ? this.silo.sections.length : 0;
                    //this.loadSections(size, siteId, siloId, this.date.getTime() / 1000);
                    this.sections = this.silo.sections;
                    //Recorremos todas las secciones y agreamos el campo okSensor
                    let i;
                    for(i=0;i<this.sections.length;i++)
                    {
                        this.sections[i].okSensor = true;
                    }

                }).catch(reason => {
                    console.error("Error al traer el silo", reason);
                })

            },
            convertIndex(type)
            {
                 let indice;
                //Rebautizamos los tipos para no cambiar todo
                switch(type)
                {
                    case "temp":
                        indice = "temp";
                    break;

                    case "hum":
                        indice = "hum";
                    break;

                    case "co2":
                        indice = "CO2";
                    break;
                    
                    case "moisture":
                        indice = "hum_grano";
                    break;

                    default: //Tipo invalido, retornamos no data
                    return false;
                }
                return indice;
            },
            /*buildText(type, value) {
                if (value && value.length > 0 && value[value.length - 1]) {
                    return unitConverter.convertTo(type, value[value.length - 1][type], this.$store.getters.unit(type)) + " " + this.$store.getters.unit(type);
                } else {
                    return this.$t("REPORTS.NO_DATA");
                }
            },
            */
            buildText(type,value,index)
            {
                let indice;
                let self = this;

                indice = this.convertIndex(type);

                if(indice === false)
                {
                    return this.$t("REPORTS.NO_DATA");
                }
                if(!value)
                {
                    return this.$t("REPORTS.NO_DATA");
                }
                if(!value[indice])
                {
                    return this.$t("REPORTS.NO_DATA");
                }
                if(isNaN(value[indice]))
                {
                    //console.log("Valor Secciones ",self.sections," Indice: ",index );
                    if(self.sections[index] != undefined)
                    {
                        self.sections[index].okSensor = false;
                    }
                    
                    return "-";
                }

                return unitConverter.convertTo(type,value[indice], this.$store.getters.unit(type)) + " " + this.$store.getters.unit(type);
               

            },
            loadSections(size, siteId, SiloId, from) {
                this.pendingSectionResult = new Array(size);
                for (let i = 0; i < size; i++) {
                    this.pendingSectionResult.splice(i, 1, {awaiting: true, data: []});
                    api.getHistorics(siteId, SiloId, i + 1, from, from + DAY_IN_SECS).then(value => {
                        this.pendingSectionResult.splice(i, 1, {awaiting: false, data: value.history});
                    }).catch(reason => {
                        this.pendingSectionResult.splice(i, 1, {awaiting: false, data: []});
                    });
                }
            },
            backgroundColor(type, section) {

                let backgroundClasses = ["no_data", "ok", "warn", "danger", "none", "disabled"];
                if (section === undefined) {
                    return "";
                }

                return "background-image-container__image--" + backgroundClasses[this.getStatus(type, section)];
            },
            getStatusColor(section)
            {
               // return " ";

                if((!section) || (!section["status"]))
                {
                    return " ";
                }
                switch (section["status"])
                {
                    case 1:
                    return "-green ";
                    
                    case 2:
                    return "-yellow ";

                    case 3:
                    return "-red ";
                }

                return " ";
            },
            backgroundSiloColor(position,section)
            {
                let classStart = "background-image-container background-image-container__";
                let classEnd = undefined;
                let color = " ";

                switch(position)
                {
                    case "left":
                        classEnd = "align-items-end";
                    break;

                    case "center":
                        classEnd = "";
                    break;

                    case "right":
                        classEnd = "align-items-start"
                    break;
                    
                }
                if(this.siloColor)
                {
                    color = this.getStatusColor(section);
                }
                

                return classStart + position + "-border-image" + color + classEnd;
            },
            /*
            getStatus(type, section) {
                if (section && section.length > 0 && section[0]) {
                    let data = section[0];
                    if (this.limits === undefined || this.limits[type] === undefined || data[type] === undefined) {
                        return 0;
                    }
                    let status;
                    delete data.date;

                    const value = unitConverter.convertTo(type, data[type], this.$store.getters.unit(type));
                    const A = unitConverter.convertTo(type, this.limits[type].status[2].min_end, this.$store.getters.unit(type));
                    const B = unitConverter.convertTo(type, this.limits[type].status[0].min_start, this.$store.getters.unit(type));
                    const C = unitConverter.convertTo(type, this.limits[type].status[0].max_end, this.$store.getters.unit(type));
                    const D = unitConverter.convertTo(type, this.limits[type].status[2].max_start, this.$store.getters.unit(type));

                    if (value < A || value > D) {
                        status = 3;
                    } else if (value > A && value < B) {
                        status = 2;
                    } else if (value > B && value < C) {
                        status = 1;
                    } else if (value > C && value < D) {
                        status = 2;
                    }

                    return status;
                }
                return 0;
            },
            */
            getStatus(type, section) {
                if (section) 
                {
                    //console.log("Indice: "+indice);

                    let data = section;
                    let indice = this.convertIndex(type);
                    //console.log("Type: "+type);
                    if(!type)
                        return 0;

                    if (this.limits === undefined || this.limits[type] === undefined || data[indice] === undefined) {
                        return 0;
                    }
                    if(isNaN(data[indice]))
                    {
                        return 0;
                    }
                    
                    let status;
                    //delete data.date;

                    const value = unitConverter.convertTo(type, data[indice], this.$store.getters.unit(type));
                    const A = unitConverter.convertTo(type, this.limits[type].status[2].min_end, this.$store.getters.unit(type));
                    const B = unitConverter.convertTo(type, this.limits[type].status[0].min_start, this.$store.getters.unit(type));
                    const C = unitConverter.convertTo(type, this.limits[type].status[0].max_end, this.$store.getters.unit(type));
                    const D = unitConverter.convertTo(type, this.limits[type].status[2].max_start, this.$store.getters.unit(type));

                    if (value < A || value > D) {
                        status = 3;
                    } else if (value > A && value < B) {
                        status = 2;
                    } else if (value > B && value < C) {
                        status = 1;
                    } else if (value > C && value < D) {
                        status = 2;
                    }

                    return status;
                }
                return 0;
            },
            isOldDate(date) 
            {
                return this.today.getTime() - this.TWO_DAYS_IN_MILLIS > new Date(date).getTime()
            },
            isSensorFail(isOk)
            {
                return !isOk;
                
            },
            formatDate(date) {
                let offset = parseInt(this.$store.state.user.timezone);
                //console.log("Offset: ",offset);
                let newDate = dateFormater.dateOffset(date, offset);
                return dateFormater.dateFormat(newDate,this.$store.state.language);
            }
    
        }

    }
</script>

<style lang="scss">
    @import '~bootstrap/scss/_functions';
    @import '~bootstrap/scss/_variables';
    @import '~bootstrap/scss/mixins/_breakpoints';

    $siloColor: #6ac9d711;
    $siloRed: #fcc3b8;
    $siloYellow: rgb(255, 255, 140) ;
    $siloGreen: rgb(184, 243, 66);

    .silo-img {
        height: 100px;
    }

    .scroll-wrapper {
        overflow-x: visible;
        overflow-y: hidden;
    }

    .background-image-container {
        height: 100px;
        width: 100px;

        background-size: cover;
        background-repeat: no-repeat;
        background-position: right top;
        background-attachment: scroll;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        &__left-border-image {
            mask: url("../../assets/images/silo/greyLeft.svg");
            background: $siloColor;
        }
        
        &__left-border-image-green {
            mask: url("../../assets/images/silo/greyLeft.svg");
            background: $siloGreen;
        }

        &__left-border-image-yellow {
            mask: url("../../assets/images/silo/greyLeft.svg");
            background: $siloYellow;
        }

        &__left-border-image-red {
            mask: url("../../assets/images/silo/greyLeft.svg");
            background: $siloRed;
        }


        &__right-border-image {
            mask: url("../../assets/images/silo/greyRight.svg");
            background: $siloColor;
            margin-left: 0.5em;
        }

       &__right-border-image-green {
            mask: url("../../assets/images/silo/greyRight.svg");
            background: $siloGreen ;
            margin-left: 0.5em;
        }

       &__right-border-image-yellow {
            mask: url("../../assets/images/silo/greyRight.svg");
            background: $siloYellow ;
            margin-left: 0.5em;
        }

       &__right-border-image-red {
            mask: url("../../assets/images/silo/greyRight.svg");
            background: $siloRed ;
            margin-left: 0.5em;
        }


        &__center-border-image {
            mask: url("../../assets/images/silo/greyCenter.svg");
            background: $siloColor;
            margin-left: 0.5em;
        }

        &__center-border-image-green {
            mask: url("../../assets/images/silo/greyCenter.svg");
            background: $siloGreen;
            margin-left: 0.5em;
        }
        
        &__center-border-image-yellow {
            mask: url("../../assets/images/silo/greyCenter.svg");
            background: $siloYellow;
            margin-left: 0.5em;
        }

        &__center-border-image-red {
            mask: url("../../assets/images/silo/greyCenter.svg");
            background: $siloRed;
            margin-left: 0.5em;
        }


        &__image {
            &--no_data {
                color: #727272;
            }

           /* &--ok {
                color: #37B34A;
                opacity: 0.6;
            }

            &--warn {
                color: #ffb400;
                opacity: 0.6
            }

            &--danger {
                color: #c4183c;
                opacity: 0.6;
            }
            */
            &--ok {
                color: rgb(32, 114, 44);
                opacity: 0.6;
            }

            &--warn {
                color: #c08600;
                opacity: 0.6
            }

            &--danger {
                color: #c4183c;
                opacity: 0.6;
            }
            
            &--none {
                color: #ccc;
            }

            &--disabled {
                color: black;
            }
        }


    }


</style>